import { APIForm } from './_api-form.js';
class ResetPassword extends APIForm {
  constructor() {
    super();
    this._successRedirectUrl = null;
  }
  connectedCallback() {
    super.connectedCallback();
    // Get the success redirect URL from the data-success attribute
    this._successRedirectUrl = this.getAttribute('data-success');
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  _getDefaultEndpoint() {
    return "/wp-json/api/v1/ambassador/password-reset";
  }
}
customElements.define('reset-password', ResetPassword);